import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useServiceBotEnabled() {
  const serviceBot = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.ServiceBot),
  )

  return serviceBot?.enabled ?? false
}
